import { Component } from "react";
import { connect } from "react-redux";
import { CalculatePrice_PickupDelivery_Worker } from "../../../../../../helper/worker/CalculatePrice_PickupDelivery_Worker";
import { CanOrderCalculateTravelCost } from "../../../../../../helper/worker/CanOrderCalculateTravelCost";
import momentJalaali from "moment-jalaali";

class App extends Component {
  componentDidMount() {
    CalculatePrice_PickupDelivery_Worker(
      {
        customerType:this.props.person ? "individual" :"business",
        customerId: this.props.customerId ,
        serviceactiveVehicleType: this.props.serviceactiveVehicleType,
        serviceoptions: this.props.serviceoptions,
        pickup: {
          address: this.props.pickup.address,
          scheduleDateAfter: momentJalaali(
            this.props.pickup.scheduleDateAfter
          ).isValid()
            ? momentJalaali(
                Number(this.props.pickup.scheduleDateAfter + "000")
              ).unix()
            : 0,
          scheduleDateBefore: momentJalaali(
            this.props.pickup.scheduleDateBefore
          ).isValid()
            ? momentJalaali(
                Number(this.props.pickup.scheduleDateBefore + "000")
              ).unix()
            : 0,
        },
        dropOff: {
          address: this.props.dropOff.address,
          scheduleDateAfter: momentJalaali(
            this.props.dropOff.scheduleDateAfter
          ).isValid()
            ? momentJalaali(
                Number(this.props.dropOff.scheduleDateAfter + "000")
              ).unix()
            : 0,
          scheduleDateBefore: momentJalaali(
            this.props.dropOff.scheduleDateBefore
          ).isValid()
            ? momentJalaali(
                Number(this.props.dropOff.scheduleDateBefore + "000")
              ).unix()
            : 0,

        },
        pickupadresss_loc: this.props.pickupadresss_loc,
        dropOffadresss_loc:this.props.dropOffadresss_loc ,
        isScheduled:DetectIsSchedule(this.props.pickup) || DetectIsSchedule(this.props.dropOff)

      },
      this.props.dispatch
    );
  }

  componentWillReceiveProps(nextProps) {
    CanOrderCalculateTravelCost(
      {
        customerType:this.props.person ,
        serviceactiveVehicleType: this.props.serviceactiveVehicleType,
        serviceoptions: this.props.serviceoptions,
        pickupadresss_loc: this.props.pickupadresss_loc,
        dropOffadresss_loc:this.props.dropOffadresss_loc
      },
      {
        customerType:nextProps.person ,
        serviceactiveVehicleType: nextProps.serviceactiveVehicleType,
        serviceoptions: nextProps.serviceoptions,
        pickupadresss_loc: nextProps.pickupadresss_loc,
        dropOffadresss_loc:nextProps.dropOffadresss_loc
      },
      (call) => {

        if (call) {
          CalculatePrice_PickupDelivery_Worker(
            {
              customerId: nextProps.customerId ,
              customerType:nextProps.person? "individual" :"business",
              serviceactiveVehicleType: nextProps.serviceactiveVehicleType,
              serviceoptions: nextProps.serviceoptions,
              pickup: {
                address: nextProps.pickup.address,
                scheduleDateAfter: momentJalaali(
                  nextProps.pickup.scheduleDateAfter
                ).isValid()
                  ? momentJalaali(
                      Number(nextProps.pickup.scheduleDateAfter + "000")
                    ).unix()
                  : 0,
                scheduleDateBefore: momentJalaali(
                  nextProps.pickup.scheduleDateBefore
                ).isValid()
                  ? momentJalaali(
                      Number(nextProps.pickup.scheduleDateBefore + "000")
                    ).unix()
                  : 0,
              },
              dropOff: {
                address: nextProps.dropOff.address,
                scheduleDateAfter: momentJalaali(
                  nextProps.dropOff.scheduleDateAfter
                ).isValid()
                  ? momentJalaali(
                      Number(nextProps.dropOff.scheduleDateAfter + "000")
                    ).unix()
                  : 0,
                scheduleDateBefore: momentJalaali(
                  nextProps.dropOff.scheduleDateBefore
                ).isValid()
                  ? momentJalaali(
                      Number(nextProps.dropOff.scheduleDateBefore + "000")
                    ).unix()
                  : 0,
              },
              pickupadresss_loc: nextProps.pickupadresss_loc,
              dropOffadresss_loc: nextProps.dropOffadresss_loc,
              isScheduled:DetectIsSchedule(nextProps.pickup) || DetectIsSchedule(nextProps.dropOff)
            },
            this.props.dispatch
          );
        }
      }
    );
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state) => ({
  person: state.EditOrder.editOrder.customer.person,
  serviceactiveVehicleType: state.EditOrder.editOrder.service.activeVehicleType,
  serviceoptions: state.EditOrder.editOrder.service.options,
  customerId: state.ViewTravel.pureData.customerId,


  pickup: state.EditOrder.editOrder.pickup,
  pickupadresss_loc: state.EditOrder.editOrder.pickup.adresss_loc,
  dropOff: state.EditOrder.editOrder.dropOffs.firstDropOff,
  dropOffadresss_loc: state.EditOrder.editOrder.dropOffs.firstDropOff.adresss_loc,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



function DetectIsSchedule(pickup) {
  if ( (Number(pickup.scheduleDateBefore) > 0  ) || ( Number(pickup.scheduleDateAfter  )) > 0) {
    return true
  } else {
    return false

  }

}
